module.exports = require("@swa-ui/placements/src/HorizontalListAdapter/HorizontalListAdapter.module.scss");